export enum YesNoEnum {
  Y = 'Y',
  N = 'N',
}

export type YesNo = `${YesNoEnum}`;
